import { useMutation } from '@tanstack/react-query';

import { IUserCreation } from '@/features/user-management/user-management-creation/interfaces';
import { UserCreationService } from '@/features/user-management/user-management-creation/services';

export const useUserCreationMutation = () => {
  return useMutation({
    mutationFn: async (payload: IUserCreation) => {
      const response = await UserCreationService.CreateUser(payload);
      return response.data;
    },
  });
};
